<template>
  <div class="container" v-wechat-title="title">
    <div>
      <!-- 返回栏 -->
      <div>
        <nav-bar title="卖车"></nav-bar>
      </div>
      <van-form @submit="onSubmit" ref="sellCarForm" @failed="failed" :show-error="false">
        <van-cell>我要卖车</van-cell>
        <van-field clearable required v-model="params.vehicleName" name="vehicleName" label="车辆名称" placeholder="请输入车辆名称" :rules="[{ required: true, message: '请输入车辆名称' }]" />
        <van-field clearable required v-model="params.shelfCode" name="shelfCode" label="车架号" placeholder="请输入车架号" :rules="[{ required: true, message: '请输入车架号' }]" />
        <van-field clearable required v-model="params.licenseCode" name="licenseCode" label="车牌号" placeholder="请输入车牌号" :rules="[{ required: true, message: '请输入车牌号' }]" />
        <van-field clearable required v-model="params.tel" name="tel" label="联系方式" placeholder="请输入手机号" :rules="[{ pattern: telRule, required: true, message: '请输入正确的手机号' }]" />
        <van-field clearable required v-model="params.userName" name="userName" label="姓名" placeholder="请输入姓名" :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field clearable required v-model="params.describe" name="message" label="车辆描述" placeholder="如：14款奥迪A3，2万公里" :rules="[{ required: true, message: '请填写车辆描述' }]" />
        <van-field :is-link="true" clearable readonly clickable name="city" :value="params.city" label="所在城市" placeholder="点击选择城市" @click="showCityPopup = true" />
        <van-popup v-model="showCityPopup" position="right" :style="{ height: '100%', width: '80%' }">
          <div class="city_title">城市列表</div>
          <div class="city_list">
            <div v-for="item in cityList" :key="item.id" @click="chooseCity(item.text)" class="city_box">
              <span>{{ item.text }}</span>
              <span v-if="item.text == params.city" class="icon"><van-icon name="success"/></span>
            </div>
          </div>
        </van-popup>
        <van-field required name="pics" label="上传车辆图片" :rules="[{ required: true, message: '请上传车辆图片' }]">
          <template #input>
            <van-uploader v-model="params.pics" :after-read="afterRead" />
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button block type="info" native-type="submit" :disabled="disabled">
            {{ text }}
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import ossClient from '@/utils/alioss'
export default {
  data() {
    return {
      title: '我要卖车',
      params: { vehicleName: '', shelfCode: '', licenseCode: '', tel: '', userName: '', describe: '', city: '', pics: [] },

      telRule: /^1[3456789]\d{9}$/,
      showCityPopup: false,
      disabled: false,
      text: '预约卖车',
      cityList: [],

      uploadConf: {
        accessKeyId: 'LTAI4Ft3sQrSb3EGtJswDPTX',
        accessKeySecret: 'qNIm3LWCQISpYFlnSfMzq4TAYpwGtG',
        bucket: 'new-store',
        region: 'oss-cn-beijing'
      } // 配置对象
    }
  },
  created() {
    this.getCityList()
  },
  methods: {
    async getCityList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/listArea')
      if (data.success) {
        this.cityList = data.data.list
        this.params.city = this.cityList[0].text
      }
    },
    chooseCity(value) {
      this.params.city = value
      this.showCityPopup = false
    },
    afterRead({ file }) {
      // 此时可以自行将文件上传至服务器

      var that = this
      console.log(file)
      // const { imgName } = 'ALIOSS_IMG_'
      // const fileName = `${imgName}/${Date.parse(new Date())}` // 定义唯一的文件名
      var suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      var randName = 'pic_' + new Date().getTime() + Math.floor(Math.random() * 10000)
      var fileName = randName + '.' + suffix
      ossClient(this.uploadConf)
        .put(fileName, file, {
          ContentType: 'image/jpeg'
        })
        .then(({ res, url, username }) => {
          if (res && res.status == 200) {
            console.log('阿里云OSS上传图片成功回调', res, url, username)
            // that.params.pics.push({
            //   name: file.name,
            //   url: url
            // })
            that.params.pics[that.params.pics.length - 1].url = url
            that.params.pics[that.params.pics.length - 1].name = file.name
          }
        })
        .catch(err => {
          console.log('阿里云OSS上传图片失败回调', err)
        })
    },
    async onSubmit(value) {
      var that = this
      // var index = this.cityList.findIndex(item => item.text == value.city)
      // var cityId = this.cityList[index].value
      value.pics.forEach(item => {
        delete item.content
        delete item.file
        delete item.content
        delete item.status
        delete item.message
      })
      var params = {
        vehicleName: value.vehicleName,
        shelfCode: value.shelfCode,
        licenseCode: value.licenseCode,
        condDesc: value.message,
        username: value.userName,
        usertel: value.tel,
        coverUrl: value.pics[0].url,
        pics: value.pics
      }
      const { data } = await this.$http.post(that.$store.state.web4open_api + '/web/vehicleSale/doVehicleSaleAdd', JSON.parse(JSON.stringify(params)))
      if (data.success) {
        this.$dialog
          .alert({
            message: '您已成功预约卖车，稍后会有您的专属汽车顾问联系您，请保持通话顺通。'
          })
          .then(() => {
            this.disabled = true
            this.text = '您已成功预约卖车'
          })
      }
    },

    failed() {
      this.$dialog
        .alert({
          message: '请输入正确的信息'
        })
        .then(() => {
          this.$refs.sellCarForm.resetValidation('vehicleName')
          this.$refs.sellCarForm.resetValidation('shelfCode')
          this.$refs.sellCarForm.resetValidation('licenseCode')
          this.$refs.sellCarForm.resetValidation('tel')
          this.$refs.sellCarForm.resetValidation('userName')
          this.$refs.sellCarForm.resetValidation('message')
          this.$refs.sellCarForm.resetValidation('city')
          this.$refs.sellCarForm.resetValidation('pics')
        })
    },
    back() {
      this.brandBoxIsShow = false
      this.seriesPopupShow = false
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.van-field {
  padding: 10px 16px;
}
.line {
  height: 14px;
  background-color: #f2f2f2;
}
.city_title {
  background-color: #f2f2f2;
  padding: 0 14px;
  line-height: 1.5;
  position: fixed;
  width: 100%;
}
.city_list {
  padding: 0 14px;
  position: fixed;
  overflow: scroll;
  height: 6.5rem;
  width: 100%;
  margin-top: 20px;
  .city_box {
    border-bottom: 1px solid #f2f2f2;
    line-height: 2.5;
    display: flex;
    justify-content: space-between;
    .icon {
      color: #1989fa;
      font-size: 16px;
    }
  }
}
</style>
